import { Edge } from "@xyflow/react";
import { OutgoingBackendEdge } from "../types";
import { isTempEdge } from "./isTempEdge";

// zap step ids are this format: zap-${zapNode.id}-${step.id}
export function extractZapNodeId(nodeId: string): string {
  return nodeId.split("-").slice(1, -1).join("-");
}

export function extractZapStepId(nodeId: string): string | null {
  const match = nodeId.match(/(\d+)$/);
  return match?.[1] ?? null;
}

// Reverse of convertBackendEdgeToReactFlowEdge
export function convertReactFlowEdgeToBackendEdge(
  edge: Edge,
): OutgoingBackendEdge {
  const baseEdge = {
    id: edge.id,
    source_handle: edge.sourceHandle ?? null,
    target_handle: edge.targetHandle ?? null,
    label: (edge.label as string | undefined) ?? null,
  };

  if (edge.source.startsWith("zap") && edge.target.startsWith("zap")) {
    return {
      ...baseEdge,
      source_id: extractZapNodeId(edge.source),
      target_id: extractZapNodeId(edge.target),
      source_zap_step_id: extractZapStepId(edge.source),
      target_zap_step_id: extractZapStepId(edge.target),
    };
  }

  if (edge.source.startsWith("zap")) {
    return {
      ...baseEdge,
      source_id: extractZapNodeId(edge.source),
      target_id: edge.target,
      source_zap_step_id: extractZapStepId(edge.source),
      target_zap_step_id: null,
    };
  }

  if (edge.target.startsWith("zap")) {
    return {
      ...baseEdge,
      source_id: edge.source,
      target_id: extractZapNodeId(edge.target),
      source_zap_step_id: null,
      target_zap_step_id: extractZapStepId(edge.target),
    };
  }

  return {
    ...baseEdge,
    source_id: edge.source,
    target_id: edge.target,
    source_zap_step_id: null,
    target_zap_step_id: null,
  };
}

export function processEdgesBeforeSave(edges: Edge[]): OutgoingBackendEdge[] {
  return edges.reduce<OutgoingBackendEdge[]>((acc, edge) => {
    if (edge.type !== "zapStepEdge" && !isTempEdge(edge)) {
      /** Remove the 'selected' property from each edge so when you open a Canvas, nothing is selected.
       Remove className since UI presentation should not be stored as state.
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { selected, className, markerEnd, markerStart, ...rest } = edge;

      const backendEdge = convertReactFlowEdgeToBackendEdge(rest);
      acc.push(backendEdge);
    }

    return acc;
  }, []);
}
